import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';
import {
  fetchLeagueList,
  fetchTeamsList,
  clearTeamsList,
  changeUpdateN,
} from './actions';

export const initialState = {
  imagesN: 0,
  apiList: [],
  teamList: [],
  updateN: 0,
};

export const reducer = handleActions(
  {
    [fetchTeamsList]: {
      next: (state, { payload }) => {
        if (payload) {
          const newState = update(state, {
            teamList: { $set: payload },
          });
          return newState;
        } else {
          return state;
        }
      },
      throw: state => {
        return update(state, { teamList: { $set: [] } });
      },
    },
    [fetchLeagueList]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          apiList: { $set: payload || [] },
        });
        return newState;
      },
      throw: state => {
        return update(state, {
          apiList: { $set: [] },
          teamList: { $set: [] },
        });
      },
    },
    [clearTeamsList]: {
      next: state => {
        return update(state, {
          teamList: { $set: [] },
        });
      },
    },
    [changeUpdateN]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          updateN: { $set: payload || 0 },
        });

        return newState;
      },
      throw: state => {
        return update(state, {
          updateN: { $set: 0 },
        });
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
